import { useQuery } from "@tanstack/react-query";
import { getPages } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch all published pages
 */
export function useGetPages() {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["pages", i18next.language],
        queryFn: () => getPages(),
        retry: false,
    });

    const pages = data?.data?.data || [];

    return { isLoading, error, pages, refetch };
}
